<template>
  <!--  -->
  <div class="pt-16">
    <!--  -->
    <section class="bg-gray-100 bg-opacity-50 p-2 h-screen w-full">
      <!--  -->
      <div class="mx-auto container max-w-5xl bg-gray-300 shadow-md">
        <!--  -->
        <div class="bg-gray-100 p-4 border-t-4 bg-opacity-5 border-green-500 rounded-t">
          <!--  -->
          <div class="d-flex align-items-center">
            <!--  -->
            <div class="relative flex gap-1 items-center justify-center">
              <!--  -->
              <svg class="fill-current" width="26" height="26" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                <path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm8.127 19.41c-.282-.401-.772-.654-1.624-.85-3.848-.906-4.097-1.501-4.352-2.059-.259-.565-.19-1.23.205-1.977 1.726-3.257 2.09-6.024 1.027-7.79-.674-1.119-1.875-1.734-3.383-1.734-1.521 0-2.732.626-3.409 1.763-1.066 1.789-.693 4.544 1.049 7.757.402.742.476 1.406.22 1.974-.265.586-.611 1.19-4.365 2.066-.852.196-1.342.449-1.623.848 2.012 2.207 4.91 3.592 8.128 3.592s6.115-1.385 8.127-3.59zm.65-.782c1.395-1.844 2.223-4.14 2.223-6.628 0-6.071-4.929-11-11-11s-11 4.929-11 11c0 2.487.827 4.783 2.222 6.626.409-.452 1.049-.81 2.049-1.041 2.025-.462 3.376-.836 3.678-1.502.122-.272.061-.628-.188-1.087-1.917-3.535-2.282-6.641-1.03-8.745.853-1.431 2.408-2.251 4.269-2.251 1.845 0 3.391.808 4.24 2.218 1.251 2.079.896 5.195-1 8.774-.245.463-.304.821-.179 1.094.305.668 1.644 1.038 3.667 1.499 1 .23 1.64.59 2.049 1.043z"/>
              </svg>
              <!--  -->
              <span>{{ user.fullName }}</span>
              <!--  -->
              <span class="flex items-center justify-center" v-if="user.type === 'Seller' && user.identity.status === 'valid'">
                <svg class="w-4 h-4 text-blue-500" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" height="20px" width="20px" version="1.1" id="Filled_Icons" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
                  <path d="M20.32,8.56c-0.51-1.22,0.38-3.41-0.54-4.33c-0.92-0.92-3.11-0.03-4.33-0.54C14.27,3.19,13.36,1,12,1S9.73,3.19,8.56,3.68   C7.33,4.19,5.14,3.3,4.22,4.22C3.3,5.14,4.19,7.33,3.68,8.56C3.19,9.73,1,10.64,1,12s2.19,2.27,2.68,3.44   c0.51,1.22-0.38,3.41,0.54,4.33c0.92,0.92,3.11,0.03,4.33,0.54C9.73,20.81,10.64,23,12,23s2.27-2.19,3.44-2.68   c1.22-0.51,3.41,0.38,4.33-0.54c0.92-0.92,0.03-3.11,0.54-4.33C20.81,14.27,23,13.36,23,12S20.81,9.73,20.32,8.56z M11,16.41   l-3.71-3.71l1.41-1.41L11,13.59l5.29-5.29l1.41,1.41L11,16.41z" fill="currentColor"/>
                </svg>
              </span>
            </div>
            <!--  
            <div class="font-22 ms-auto">
              <button @click="$vm2.open('Identity')" :class="!user.identity || (user.identity && user.identity.status === 'invalid') ? 'animation-pulse' : ''" class="dt-button buttons-excel buttons-html5 uppercase">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="fill-current mr-2">
                  <path  d="M14 18.597v.403h-10v-.417c-.004-1.112.044-1.747 1.324-2.043 1.403-.324 2.787-.613 2.122-1.841-1.973-3.637-.563-5.699 1.554-5.699 2.077 0 3.521 1.985 1.556 5.699-.647 1.22.688 1.51 2.121 1.841 1.284.297 1.328.936 1.323 2.057zm6-9.597h-4v2h4v-2zm0 4h-4v2h4v-2zm0 4h-4v2h4v-2zm-4-12v2h6v14h-20v-14h6v-2h-8v18h24v-18h-8zm-6-4v6h4v-6h-4zm2 4c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z"></path>
                </svg>
                <span>Identité</span>
              </button>
            </div> -->
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="bg-white space-y-6">
          <!--  -->
          <div v-if="messages" class="alert mx-2 alert-outline-warning flex items-center mb-2 show" role="alert" style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="bx-burst lucide w-6 h-6 mr-2">
              <circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            {{messages}}
          </div>
          <!--  -->

          <!--  -->
          <div class="md:inline-flex md:s pace-y-0 w-full p-2 text-gray-600 items-center">
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm text-gray-500">{{$t('email')}}</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">mail</i>
                </div>
                <span class="p-2">{{ user.email }}</span>
              </div>
            </div>
            <!--  -->

            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm text-gray-500">{{$t('role')}}</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">lock</i>
                </div>
                <input type="text" v-model="user.role.name" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="role" disabled/>
              </div>
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center">
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm text-gray-500"> {{$t('fullname')}}</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">person</i>
                </div>
                <input type="text" v-model="user.fullName" disabled class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="fullName"/>
              </div>
            </div>
            <!--  -->

            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm text-gray-500"> {{$t('phone')}}</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">person</i>
                </div>
                <input type="text" v-model="user.phone" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="phone"/>
              </div>
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center">
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm text-gray-500"> {{$t('username')}}</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">person</i>
                </div>
                <input type="text" v-model="user.username" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="username" @keydown.space="(event) => event.preventDefault()" @keydown="nameKeydown($event)" :disabled="isDisabled" />
              </div>
            </div>
            <!--  -->

            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm text-gray-500">{{$t('store')}}</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">business</i>
                </div>
                <input type="text" v-model="user.company" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" placeholder="company"/>
              </div>
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="user.type === 'Seller'" class="md:inline-flex md:space-y-0 w-full p-1 text-gray-600 items-center">
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto">
              <label class="text-sm text-gray-500">{{$t('RIB OR WISE OR IBAN ...')}}</label>
              <div class="w-full rounded-md inline-flex border">
                <div class="pt-2 rounded-md w-1/12 bg-gray-100">
                  <i class="material-icons px-1">call_to_action</i>
                </div>
                <input type="text" v-model="user.rib" class="w-11/12 focus:outline-none rounded-md bg-white focus:text-gray-600 p-2" :placeholder="$t('rib')"/>
              </div>
            </div>
            <!--  -->
            <div class="md:w-2/3 max-w-sm mx-auto"></div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <hr />
          <!--  -->

          <!--  -->
          <div class="md:inline-flex w-full space-y-4 md:space-y-0 justify-center text-gray-600 items-center">
            <span class="text-gray-700 font-semibold">{{$t('change_password')}} </span>
            <div class="md:w-1/12 justify-end text-center md:pl-6">
              <button class="text-white hover:bg-green-600  rounded-full bg-green-600  flex items-center focus:outline-none p-2 ml-2">
                <i class="material-icons">keyboard_arrow_up</i>
              </button>
            </div>
          </div>
          <!--  -->

          <!--  -->
          <hr />
          <!--  -->

          <!--  -->
          <div class="md:inline-flex w-full space-y-4 md:space-y-0 p-4 text-gray-600 items-center">
            <!--  -->
            <div class="md:w-5/12 w-full md:pl-9 max-w-sm mx-auto space-y-5 md:inline-flex pl-2">
              <!--  -->
              <div class="w-full inline-flex border-b hover:border-green-500">
                <!--  -->
                <div class="w-1/12 pt-2">
                  <svg fill="none" class="w-6 text-gray-500 mx-auto" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                  </svg>
                </div>
                <!--  -->
                <input type="password" v-model="user.password" class="w-11/12 focus:outline-none focus:text-gray-600 p-2 ml-4" placeholder="New password"/>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="md:w-5/12 w-full md:pl-9 max-w-sm mx-auto space-y-5 md:inline-flex pl-2">
              <div class="w-full inline-flex border-b hover:border-green-500 ">
                <div class="w-1/12 pt-2">
                  <svg fill="none" class="w-6 text-gray-500 mx-auto" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                  </svg>
                </div>
                <input type="password" v-model="user.confirmPassword" class="w-11/12 focus:outline-none focus:text-gray-600 p-2 ml-4" placeholder="Confirm password"/>
              </div>
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <hr />
          <!--  -->

          <!--  -->
          <div class="md:inline-flex w-full space-y-4 justify-center md:space-y-0 p-2 text-gray-600 items-center">
            <div class="md:w-3/12 text-center md:pl-6 pb-8">
              <button :disabled="loading" @click="update" class="text-white w-full mx-auto max-w-sm rounded text-center bg-green-600  py-2 px-8 inline-flex items-center focus:outline-none md:float-right">
                <i class="material-icons mr-8">save </i>
                {{$t('save')}}
              </button>
            </div>
          </div>
          <!--  -->

          <!--  -->
          <div v-if="user.status == 'inactive'" class="ml-20 mr-20 pb-20">
            <!--  -->
            <div class="alert flex flex-row items-center bg-yellow-200 p-5 rounded border-b-2 border-yellow-300">
              <!--  -->
              <div class="alert-icon flex items-center bg-yellow-100 border-2 border-yellow-500 justify-center h-10 w-10 flex-shrink-0 rounded-full">
                <span class="text-yellow-500">
                  <svg fill="currentColor" viewBox="0 0 20 20" class="h-6 w-6">
                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                  </svg>
                </span>
              </div>
              <!--  -->

              <!--  -->
              <div class="alert-content ml-4">
                <!--  -->
                <div class="alert-title font-semibold text-lg text-yellow-800">
                    {{$t('warning')}}
                </div>
                <!--  -->
                <div class="alert-description text-sm text-yellow-600">
                    {{$t('must_shange_pass')}}
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </section>
    <!--  -->

    <!--ModalIdentity -->
    <vue-modal-2 name="Identity" v-if="user.identity" :headerOptions="{ title: 'Identité' }" :noFooter="true" modalSize="lg" @on-close="$vm2.close('Identity')">
      <!--  -->
      <div class="bg-white rounded-lg">
        <!--  -->
        <div class="flex items-center justify-center text-base">
          <span class="text-green-500" v-if="user.identity.status === 'valid'">votre identité est <b>valide</b> avec succès</span>
          <span class="text-red-500" v-else-if="user.identity.status === 'invalid'">Veuillez ajouter vos <b>identités</b> *</span>
          <span class="text-yellow-500" v-else>En <b>attends</b> de validation</span>
        </div>
        <!--  -->
        
        <!--  -->
        <div class="px-4 mt-5 pb-1 mb-20">
          <!--  -->
          <div class="grid lg:grid-cols-2 gap-6">
              <!--  -->
              <div class="h-fit border hover:border-green-500 focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p><label for="name" class="bg-white text-gray-700 px-1">{{$t('Carte nationale')}} <span :class="$colors.required">*</span></label></p>
                </div>
                <!--  -->

                <!--  -->
                <div class="flex mt-2 mb-2  items-center justify-center bg-grey-lighter">
                    <!--  -->
                    <label class="flex flex-col items-center p-4 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue">
                        <!--  -->
                        <input v-if="user.identity.status === 'invalid'" type='file' @change="handleImage($event,'identity')" class="hidden" accept="image/*"/>
                        <!--  -->
                        
                        <!--  -->
                        <div v-if="!user.identity.identity" class="flex flex-col gap-4 mb-4">
                          <div class="flex flex-col items-center justify-center gap-2">
                            <!--  -->
                            <svg class="w-6 h-6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                              <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <!--  -->
  
                            <!--  -->
                            <span class="text-sm leading-normal ">
                              {{$t('select_image')}}
                            </span>
                            <!--  -->
                          </div>

                          <!--  -->
                          <span class="flex flex-col gap-1 bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4" style="font-size: 11px;" role="alert">
                            <p>La taille de image doit pas dépasser 500 ko</p>
                            <div class="flex flex-col gap-1 text-center">
                              <span class="text-gray-700">Exemple Image</span>
                              <img class="img-exemple"  src="https://storeno.b-cdn.net/codinafrica-v1/6-2024/1718117877363.png" alt="" />
                            </div>
                          </span>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <img class="w-full h-full object-contain" v-if="user.identity.identity" :src="user.identity.identity" alt="" />
                        <!--  -->
                    </label>
                    <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
              
              <!--  -->
              <div class="h-fit border hover:border-green-500 focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <p><label for="name" class="bg-white text-gray-700 px-1">{{$t('Photo selfie')}} <span :class="$colors.required">*</span></label></p>
                </div>
                <!--  -->

                <!--  -->
                <div class="flex mt-2 mb-2  items-center justify-center bg-grey-lighter">
                    <!--  -->
                    <label class="flex flex-col items-center p-4 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue">
                        <!--  -->
                        <input v-if="user.identity.status === 'invalid'" type='file' @change="handleImage($event,'selfie')" class="hidden" accept="image/*"/>
                        <!--  -->
                        
                        <!--  -->
                        <div v-if="!user.identity.selfie" class="flex flex-col gap-4 mb-4">
                          <div class="flex flex-col items-center justify-center gap-2">
                            <!--  -->
                            <svg class="w-6 h-6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                              <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                            </svg>
                            <!--  -->
  
                            <!--  -->
                            <span class="text-sm leading-normal ">
                              {{$t('select_image')}}
                            </span>
                            <!--  -->
                          </div>

                          <!--  -->
                          <span class="flex flex-col gap-1 bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4" style="font-size: 11px;" role="alert">
                            <p>La taille de image doit pas dépasser 500 ko</p>
                            <div class="flex flex-col gap-1 text-center">
                              <span class="text-gray-700">Exemple Image</span>
                                <img class="img-exemple"  src="https://storeno.b-cdn.net/codinafrica-v1/6-2024/1718116538166.jpeg" alt="" />
                            </div>
                          </span>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <img class="w-full h-full object-contain" v-if="user.identity.selfie" :src="user.identity.selfie" alt="" />
                        <!--  -->
                    </label>
                    <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="modal-footer flex items-center justify-between text-right">
          <!--  -->
          <button @click="$vm2.close('Identity')" :class="loading ? 'noselect' : ''" class="flex text-white w-fit rounded text-center bg-gray-500 mx-4 py-2 px-8 items-center focus:outline-none md:float-right">Fermer</button>
          <!--  -->
          <button v-if="user.identity.status === 'invalid'" @click="update(true)" :class="loading ? 'noselect' : ''" class="flex text-white w-fit rounded text-center bg-green-600 mx-4 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative">
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            Enregistrer
          </button>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </vue-modal-2>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import DivFilter from "../components/DivFilter.vue";
export default {
  components: { DivFilter },
  name: "Profil",
  props: {
    currentUser: { type: Object},
  },
  data() {
    return {
      user: this.currentUser,
      isDisabled: false,
      show: false,
      loading:false,
      fullPage:false,
      messages:'',
    };
  },
  async mounted() {
    this.token = this.$jwtService.verifyToken();
    this.getUser();
  },
  methods: {
    async getUser() {
      if(this.user.username) this.isDisabled = true;

     /* if(!this.user.identity) {
        this.user.identity = { isIdentity: false, status: 'invalid', identity: null, selfie: null };
      }

      if(this.user.type === 'Seller' && this.user.identity.isIdentity === true &&
        this.user.identity.identity === null && this.user.identity.selfie === null) {
        this.$vm2.open('Identity');
      }*/

      this.checkUserMessage();
    },
    checkUserMessage(){
      this.messages='';
      if(this.user.type === "Seller" && (!this.user.fullName || !this.user.rib)){
        if(!this.user.fullName) this.messages='full Name is required ';
        if(!this.user.rib){
          if(!this.user.fullName) this.messages +='&& ';
          this.messages +='RIB is required ';
        }
      }
    },
    handleImage(e,action){
      const selectImage=e.target.files[0];
      if(selectImage){
        const reader=new FileReader();
        reader.readAsDataURL(selectImage);
        reader.onload= () =>{
          if(action === 'identity') this.user.identity.identity= reader.result;
          if(action === 'selfie') this.user.identity.selfie= reader.result;
        };
      }
    },
    showBar() {
      if (this.show) this.show = false;
      else this.show = true;
    },
    async update(identity = false) {
      if(this.checkData()){
       /* if(!this.$f.checkSize(this.user.identity.identity) || !this.$f.checkSize(this.user.identity.selfie)) {
            let typeImage = 'Carte nationale';
            if(!this.$f.checkSize(this.user.identity.selfie)) typeImage= 'Photo selfie';
            this.$toast.warning(`La Taille de image (${typeImage}) doit pas dépasser 500 KO`);
            return false;
        }*/

        this.$confirm("Es-tu sûr ?").then(async (res) => {
          if (res) {
          //
          if(this.user.password) this.user.password= this.user.password.trim();
          if(this.user.confirmPassword) this.user.confirmPassword=this.user.confirmPassword.trim();

          if(this.user.identity.status === 'invalid' && identity === true) {
            this.user.identity.status = 'awaiting validation';
            this.user.identity.isIdentity = false;
          }
          
          //
            if (this.user.password) {
              if (this.checkPassword()) {
                this.loading=true;
                const data = await this.$server.update("users", this.user);
                this.loading=false;
                if (data && data._id) {
                  this.$toast.success("Profile updated");
                  this.$vm2.close('Identity');
                  this.logout();
                  this.user.password = "";
                  this.user.confirmPassword = "";
                } else this.$toast.warning(data);
              }
            } else {
              this.loading= true;
              const data= await this.$server.update("users", this.user);
              this.loading= false;
              if (data && data._id) {
                this.$toast.success("Profile updated");
                this.$vm2.close('Identity');
                this.checkUserMessage();
                this.$store.dispatch("actionSeller",{user: this.user}); 
                if(this.user.type === 'Seller') this.$store.dispatch("actionupdate",{update:false,NewNotifs:this.user.notifications?this.user.notifications.filter(el => !el.vue).length:0,OldNotifs:this.user.notifications?this.user.notifications.filter(el => !el.vue).length:0});
                this.user.password = "";
                this.user.confirmPassword = "";
              } else {
                this.$toast.warning(data);
                if(this.user.identity.status === 'awaiting validation' && identity === true) {
                  this.user.identity.status = 'invalid';
                  this.user.identity.isIdentity = true;
                }
              }
            }
          }
        });
      } else {
        this.$toast.warning("You must fill all the fields !!")
      } 
    },
    checkData() {
      if(this.user.type === "Seller"){
        if(this.user.rib && this.user.email && this.user.fullName) return true;
        else return false;
      }else{
        if(this.user.email) return true;
        else return false;
      }
    },
    checkPassword() {
      if (this.user.confirmPassword && this.user.password && this.user.password === this.user.confirmPassword) {
        return true;
      } else {
        this.$toast.warning(`Confirmation password does not match`);
        return false;
      }
    },
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    logout() {
      this.$jwtService.destroyToken();
      location.href = "/";
    }
  },
};
</script>


<style scoped>
.h-fit {
  height: fit-content;
}

.img-exemple{
  height: 180px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

svg {
    display: inline-block;
    vertical-align: sub;
}

.buttons-excel{
  display: inline-block;
}

.ms-auto{
    margin-left: auto !important;
}

.align-middle {
  vertical-align: middle !important;
}

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
}

.bx-burst, .bx-burst-hover:hover {
  animation: burst 1.5s infinite linear;
}

.alert-outline-warning {
  --tw-border-opacity: 1;
  border-color: #f97316;
  --tw-text-opacity: 1;
  color: #f97316;
}

.alert {
  position: relative;
  border-radius: .375rem;
  border-width: 1px;
  padding: 1rem 1.25rem;
}

.icon::after {
  content: "";
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}

@keyframes burst {
  0% {
    transform:scale(1);
    opacity:1
  }
  90% {
    transform:scale(1.5);
    opacity:0
  }
}
</style>


